import React from 'react'
import { owners } from '../../core/controllers/Owners';

export default class OwnerPMFeeChargesCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            count: 0
        }
    }

    componentDidMount() {
        var self = this;
        // owners.getOwnerTotalProperties(function(response){
        //     if (response.data != null) {
        //         self.setState({
        //             count: response.data.length
        //         });
        //     }
        // });
    }

    render(){
        const count = this.state.count;

        return (
            <div class="col-md-3 col-sm-6 col-xs-12">
                <div class="info-box">
                    <span class="info-box-icon red-icon-circle"><i class="icon-money-arrow"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text">Fee Charges</span>
                        <br/>
                        <span class="info-box-subtext">From property managers</span>
                        <span class="info-box-number red-info-number">${count}</span>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Owners/OwnerPMFeeChargesCard.jsx